<doc>鼠标绘制工具</doc>
<template>
  <div class="draw-div">
    <button class="draw-btn" @click="drawDbx()">绘制多边形</button>
    <button class="draw-btn" @click="drawDbs()">添加点标识</button>
    <button class="draw-btn" @click="drawZbd()">添加坐标点</button>
    
  </div>
</template>
<script>
export default {
  props: ["mapObject"],

  data() {
    return {
      dataList:[
            [
                116.09745010351561,
                40.186105329443336
            ],
            [
                116.07959732031249,
                39.94227090407304
            ],
            [
                116.86099990820313,
                40.009622730705274
            ],
            [
                116.84589370703124,
                40.24378288817323
            ],
            [
                116.09745010351561,
                40.186105329443336
            ]
        ]
    };
  },
  mounted(){
    
  },
  methods: {
    // 开始绘制
    drawDbx() {
      this.mapObject.addPolygon("wjwDraw",this.dataList);
    },
    drawDbs(){
      this.mapObject.addPoint('wjwDraw',this.dataList)
    },
    drawZbd(){
      this.mapObject.addSiteIcons('wjwDraw',[{ longitude:116.09745010351561,latitude:40.186105329443336 ,type:'info',img:require("../icon/sites/siteSuccess.png")}])
      //建议数组格式为[{ longitude:116.09745010351561,latitude:40.186105329443336 ,type:info}]
      //type warning success info danger 不传则为默认
      //数组内传img的话则当前对象坐标点则为自定义图标  级别高于type
      //具体情况以代码为主
    }
  },
};
</script>
<style scoped>
.draw-div {
  position: absolute;
  right: 20px;
  top: 10px;
  font-size: 12px;
  padding: 5px 10px;
  background-color: #fff;
  box-shadow: 0 2px 2px rgb(0 0 0 / 15%);
}

.draw-btn {
  width: 100%;
  margin: 5px 0;
  cursor: pointer;
}
</style>
